import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('powerfailure/list', { params });
  },
  async add(params: any) {
    return axios.post('powerfailure/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('powerfailure/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('powerfailure/detail', { params });
  },
  async delete(params: any) {
    return axios.post('powerfailure/delete', qs.stringify(params));
  }
};
